import React from 'react';

import {colors} from 'js-libs/sweetcommons/styles';
import styled from 'styled-components';

import type {ReactNode} from 'react';

type StyledMainPageHeaderProps = {
  children: ReactNode;
};

export const StyledMainPageHeaderDiv = ({
  children,
}: StyledMainPageHeaderProps): JSX.Element => (
  <div className="row align-items-center justify-content-between">
    <div className="col-12">{children}</div>
  </div>
);

export interface OptionalClassNameProps {
  className?: string;
}

export const StyledListDiv = styled.div.attrs<OptionalClassNameProps>({
  className: 'list-unstyled js-procedures-list',
})`
  margin: 0 0 20px;
`;

export const StyledCompactItemHeaderDiv = styled.div.attrs<OptionalClassNameProps>(
  {
    className: 'col-12 col-lg d-flex align-items-center',
  }
)``;

export const StyledCompactItemHeaderSpan = styled.div.attrs<OptionalClassNameProps>(
  {
    className: 'text-dark font-weight-bold d-block d-sm-inline',
  }
)``;

export const StyledSidebarH5 = styled.h5.attrs<OptionalClassNameProps>({
  className: 'text-uppercase font-weight-normal',
})`
  text-shadow: 1px 1px 1px #f2f2f2;
  color: ${colors.mediumGray};
  width: 100%;

  a {
    cursor: pointer;
  }
`;

export const StyledPopoverBottomDIV = styled.div.attrs<OptionalClassNameProps>({
  className: 'text-right',
})`
  padding: 8px 14px;
  margin-top: 0;
  background-color: #f7f7f7;
  border-top: 1px solid #ebebeb;
  border-bottom-left-radius: 0.3rem;
  border-bottom-right-radius: 0.3rem;

  &:empty {
    display: none;
  }
`;

export const StyledListRowDIV = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  justify-content: space-around;
`;
